import Model from './BaseModel';

export default class RaceBetType extends Model {
	resourceName() {
		return 'race_bet_types';
	}

	fields() {
		return ['product', 'bet_type', 'bonus_percentage'];
	}

	// override the base update for our request specific URL
	update(raceId, data) {
		return this.makePersistRequest({
			url: `${this.baseUrl()}/races/${raceId}/bet_types`,
			method: 'POST',
			data
		});
	}
}
